export default __webpack_public_path__ + "static/media/bemovil_payment.1643c026.png";